export default __webpack_public_path__ + "static/media/assassinhead.265da92e.png";